const svgArrow =
  '<svg class="carousel-pfeil" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.88 22.35"><path d="M62.68.46h0a1.44,1.44,0,0,0,.07,2h0l7.77,7.23H1.44a1.44,1.44,0,1,0,0,2.87H70.53l-7.77,7.23A1.43,1.43,0,0,0,64.62,22l.09-.08L75.59,11.8a.89.89,0,0,0,0-1.26l0,0L64.71.38a1.44,1.44,0,0,0-2,.08"/></svg>';

jQuery(document).ready(function ($) {
  class ContentCarousel {
    constructor(carousel) {
      this.$contentCarouselContainer = $(carousel);
      this.preset = this.$contentCarouselContainer.attr("data-preset");
      this.$contentCarousel =
        this.$contentCarouselContainer.find(".owl-carousel");
      this.isAlignFull = this.$contentCarouselContainer.hasClass("alignfull");

      this.normal = {
        items: 1,
        loop: true,
        dots: true,
        nav: true,
        navText: [svgArrow, svgArrow],
      };

      this.team = {
        navText: [svgArrow, svgArrow],
        loop: false,
        dots: false,
        nav: true,
        responsive: {
          0: {
            items: 1,
            margin: 0,
          },
          600: {
            items: 2,
            margin: 40,
          },
          1025: {
            items: 3,
            margin: 40,
          },
        },
      };

      this.cardsCarousel = {
        navText: [svgArrow, svgArrow],
        loop: false,
        dots: false,
        nav: true,
        margin: 80,
        responsive: {
          0: {
            items: 1,
          },
          1025: {
            items: 2,
          },
          1400: {
            items: 3,
          },
          1800: {
            items: 4,
            margin: 80,
          },
        },
      };

      this.logoCarousel = {
        loop: false,
        dots: true,
        nav: true,
        navText: [svgArrow, svgArrow],
        responsive: {
          0: {
            items: 1,
            margin: 0,
          },
          768: {
            items: 3,
            margin: 20,
          },
          1100: {
            items: 5,
            margin: 20,
          },
        },
      };

      this.settings = this.normal;
      if (this.preset == "logo-carousel") {
        this.settings = this.logoCarousel;
      } else if (this.preset == "card-carousel") {
        this.settings = this.cardsCarousel;
      } else if (this.preset == "team-carousel") {
        this.settings = this.team;
      }

      this._initCarousel();
    }

    _initCarousel() {
      const settings = this.settings;
      this.$contentCarousel.owlCarousel(settings);
    }
  }

  window.luther = window.luther || {};
  window.luther.contentcarousels = [];

  window.$(".wp-block-luther-content-carousel").each((i, el) => {
    let contentcarousel = new ContentCarousel(el);
    window.luther.contentcarousels.push(contentcarousel);
  });
});
